import 'jquery-ui/ui/widgets/slider'

export default {
  init: function () {

    const sizes = ["10", "20", "30", "40", "50", "60", "90"];
    $("#slider").slider({
      value: 2,
      min: 0,
      max: sizes.length - 1,
      step: 1,
      slide: function (event, ui) {
        $("#minutes-amount").text(sizes[ui.value]);
        $("#minutes-to-arrive").val(sizes[ui.value]);

      },
    }).each(function () {
      // Get the options for this slider
      var opt = $(this).data().uiSlider.options;

      // Get the number of possible values
      var vals = opt.max - opt.min;

      // Space out values
      for (var i = 0; i <= vals; i++) {
        let el = $("<label>" + sizes[i] + "</label>").css("left", (i / vals * 100) + "%");
        $("#slider").append(el);
      }

    });
    $("#minutes-amount").text(sizes[$("#slider").slider("value")]);
    $("#minutes-to-arrive").val(sizes[$("#slider").slider("value")]);

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/epickup.js